import request from './request';
/**
 * 查询优惠券包列表信息
 */
export function getPackageList(params) {
    return request('/package/list', {
        method: 'POST',
        params,
    });
}

/**
 * 创建优惠券包
 */
export function createPackage(params) {
    return request('/package', {
        method: 'POST',
        params,
    });
}

/**
 * 获取优惠券包详情
 */
export function getPackageDetail(id) {
    return request(`/package/${id}`, {
        method: 'GET',
    });
}

/**
 * 作废优惠券包
 */
export function cancelPackage(params) {
    return request(`/package/cancel/${params.id}`, {
        method: 'PUT',
    });
}

// 获取优惠券tab统计
export function getListCount() {
    return request('/package/orgType/count', {
        method: 'POST',
    });
}

// 获取可用优惠券包
export function getUsablePackage() {
    return request('/package/usable/list', {
        method: 'GET',
    });
}

/**
 * 获取优惠券包投放门店信息
 */
export function getPackageOrgById(id) {
    return request(`/package/package-org/${id}`, {
        method: 'GET',
    });
}

/**
 * 获取优惠券包使用信息列表
 */
export function getPackageUseInfo(id, params) {
    return request(`/package/activity-package/${id}`, {
        method: 'GET',
        params,
    });
}

/**
 * 获取优惠券包使用信息列表
 */
export function getPackageRankInfo(id) {
    return request(`/package/couponVerification/rank/${id}`, {
        method: 'GET',
    });
}
// 券包详情-使用信息-导出名单分页加导出
export function getExportList(params) {
    return request(`/package/activity-package-export-page/${params.activityId}`, {
        method: 'GET',
        params: {
            pageNum: params.pageNum,
            pageSize: params.pageSize,
            uploadFlag: params.uploadFlag,
            packageId: params.packageId,
        },
    });
}
